import { defineAsyncComponent } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import { GlDisclosureDropdown, GlDisclosureDropdownGroup, GlDisclosureDropdownItem, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { isMetaClick } from '~/lib/utils/common_utils';
import InviteMembersTrigger from '/builds/gitlab/gitlab-ee/app/assets/javascripts/invite_members/components/invite_members_trigger.vue?vue3';
import { __ } from '~/locale';
import { TOP_NAV_INVITE_MEMBERS_COMPONENT, TRIGGER_ELEMENT_DISCLOSURE_DROPDOWN } from '~/invite_members/constants';
import { CREATE_NEW_WORK_ITEM_MODAL, CREATION_CONTEXT_SUPER_SIDEBAR, WORK_ITEM_CREATE_SOURCES } from '~/work_items/constants';
export default {
    name: 'CreateMenu',
    CREATION_CONTEXT_SUPER_SIDEBAR,
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        InviteMembersTrigger,
        CreateWorkItemModal: defineAsyncComponent(()=>import('/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/create_work_item_modal.vue?vue3'))
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    i18n: {
        createNew: __('Create new…')
    },
    inject: [
        'isGroup',
        'fullPath'
    ],
    props: {
        groups: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            dropdownOpen: false,
            isCreateWorkItemModalVisible: false,
            loadCreateWorkItemModal: false
        };
    },
    methods: {
        isInvitedMembers (groupItem) {
            return groupItem.component === TOP_NAV_INVITE_MEMBERS_COMPONENT;
        },
        isCreateWorkItem (groupItem) {
            return groupItem.component === CREATE_NEW_WORK_ITEM_MODAL;
        },
        getCreateWorkItemItem (groupItem) {
            // Make sure <gl-disclosure-dropdown-item> doesn't have an href so it's
            // not rendered as <a> which prevents us from opening the create modal
            return {
                ...groupItem,
                href: undefined
            };
        },
        handleCreateWorkItemClick (event) {
            if (event && isMetaClick(event)) {
                // opening in a new tab
                return;
            }
            // don't follow the link for normal clicks - open in modal
            event?.preventDefault?.();
            this.loadCreateWorkItemModal = true;
            this.isCreateWorkItemModalVisible = true;
        }
    },
    toggleId: 'create-menu-toggle',
    TRIGGER_ELEMENT_DISCLOSURE_DROPDOWN,
    WORK_ITEM_CREATE_SOURCES
};
